var Marionette = require('marionette');


module.exports = Marionette.ItemView.extend({

    className: 'ocr_zone',

    template: false,//require('./template.hbs'),

    // this is prob small, can put on template instead ?
    // faster in template/not?
    onRender: function() {

        var model = this.model;

        this.el.id = 'zone_' + model.get('id');
        this.el.setAttribute( 'data-page-zone', model.get('page_level_id') );
        this.el.setAttribute( 'style',  model.getBoxCssStyle() );

    }


});

//



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/textLayer/zoneLayer/zone.js
 ** module id = 443
 ** module chunks = 0
 **/